import {
  ClientPerformanceMonitor,
  type ClientPerformanceMetadata,
} from './clientPerformance';

export interface BrowserClientPerformanceOptions {
  build: string;
  powerMode: () => string;
  sampleCapacity?: number;
}

function observeLongTasks(listener: (durationMs: number) => void): () => void {
  if (
    typeof PerformanceObserver === 'undefined' ||
    !PerformanceObserver.supportedEntryTypes.includes('longtask')
  ) {
    return () => undefined;
  }
  const observer = new PerformanceObserver((list) => {
    for (const entry of list.getEntries()) listener(entry.duration);
  });
  try {
    observer.observe({ type: 'longtask', buffered: true });
  } catch {
    return () => undefined;
  }
  return () => observer.disconnect();
}

export function browserPerformanceMetadata(
  build: string,
  powerMode: string,
): ClientPerformanceMetadata {
  const mobile =
    navigator.maxTouchPoints > 1 ||
    /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
  return {
    build,
    browser: navigator.userAgent,
    deviceClass: mobile ? 'mobile' : 'desktop',
    powerMode,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight,
    },
    devicePixelRatio: window.devicePixelRatio,
  };
}

export function createBrowserClientPerformanceMonitor(
  options: BrowserClientPerformanceOptions,
): ClientPerformanceMonitor {
  return new ClientPerformanceMonitor({
    enabled: true,
    sampleCapacity: options.sampleCapacity,
    metadata: () => browserPerformanceMetadata(options.build, options.powerMode()),
    now: () => performance.now(),
    observeLongTasks,
  });
}
